const Noise = "https://emanuelepapale.com/assets/images/noise.png";

export { Noise };
